export default "__VITE_ASSET__6bhdx3iE__"